import { IsArray, IsDateString, IsInt, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { UserRolesEnum } from '../../enums';

export class UserDto {
	id: string;
	name: string;
	email?: string;
	phoneNumber?: string;
	googleEmail?: string;
	createdAt: Date;
	updatedAt: Date;
	balance: number;
	roleId: UserRolesEnum;
	portfolio?: number;
	avatarSrc?: string;
	lobbyBalances?: any;
}

export class SmartRatingFilterDto {
	@IsString()
	@IsNotEmpty()
	category_id: string;

	@IsOptional()
	@IsInt()
	pageSize?: number | null;

	@IsOptional()
	@IsInt()
	page?: number | null;
}

export class RecalculateSmartRatingDto {
	@IsOptional()
	@IsArray()
	@IsString({ each: true })
	categoryIds?: string[];

	@IsOptional()
	@IsDateString()
	date?: string;
}

export class UpdateUserCategoriesDto {
	@IsOptional()
	@IsArray()
	@IsString({ each: true })
	category_ids?: string[];
}
